/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Preset_7dInputs */

const en_usage_preset_7d = /** @type {(inputs: Usage_Preset_7dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 7 days`)
};

const zh_hans1_usage_preset_7d = /** @type {(inputs: Usage_Preset_7dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近 7 天`)
};

const pt_br2_usage_preset_7d = /** @type {(inputs: Usage_Preset_7dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos 7 dias`)
};

const es_usage_preset_7d = /** @type {(inputs: Usage_Preset_7dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimos 7 días`)
};

const fr_usage_preset_7d = /** @type {(inputs: Usage_Preset_7dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 derniers jours`)
};

const de_usage_preset_7d = /** @type {(inputs: Usage_Preset_7dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte 7 Tage`)
};

const ru_usage_preset_7d = /** @type {(inputs: Usage_Preset_7dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последние 7 дней`)
};

const it_usage_preset_7d = /** @type {(inputs: Usage_Preset_7dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimi 7 giorni`)
};

/**
* | output |
* | --- |
* | "Last 7 days" |
*
* @param {Usage_Preset_7dInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const usage_preset_7d = /** @type {((inputs?: Usage_Preset_7dInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Preset_7dInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_usage_preset_7d(inputs)
	if (locale === "pt-BR") return pt_br2_usage_preset_7d(inputs)
	if (locale === "es") return es_usage_preset_7d(inputs)
	if (locale === "fr") return fr_usage_preset_7d(inputs)
	if (locale === "de") return de_usage_preset_7d(inputs)
	if (locale === "ru") return ru_usage_preset_7d(inputs)
	if (locale === "it") return it_usage_preset_7d(inputs)
	return en_usage_preset_7d(inputs)
});